<app-loading-spinner *ngIf="loadingSpinnerService.loading$ | async"></app-loading-spinner>

<!-- <div class="tab-content">
  <img src="../../assets/images/empty-feed.svg" alt="" />
  <h2>Coming soon</h2>
  <p>
    Managing your feed will be super simple and intuitive.
    We'll notify you as soon as it's ready for you to use.
  </p>
  </div> -->

<div class="tab-content">
  <div class="header">
    <div class="header-left">
      <button class="hover-button" [class.active]="isActiveTab === 'post'" (click)="setActiveTab('post')">
        Post
      </button>
      <button class="hover-button" [class.active]="isActiveTab === 'activity'" (click)="setActiveTab('activity')">
        Activities
      </button>
      <button class="hover-button" [class.active]="isActiveTab === 'event'" (click)="setActiveTab('event')">
        Events
      </button>
    </div>

    <div class="header-right" *ngIf="isActiveTab === 'event'">
      <div class="event-filter-toggle">
        <button
          type="button"
          class="event-filter-button"
          [class.active]="eventDateFilter === 'upcoming'"
          (click)="setEventDateFilter('upcoming')">
          Upcoming
        </button>
        <button
          type="button"
          class="event-filter-button"
          [class.active]="eventDateFilter === 'past'"
          (click)="setEventDateFilter('past')">
          Past
        </button>
      </div>
      <select class="form-select country-filter" [value]="selectedCountryISO" (change)="onCountryChange($any($event.target).value)">
        <option value="ARE">UAE</option>
        <option value="MKD">MKD</option>
        <option value="SRB">SRB</option>
      </select>
    </div>

    <button class="hover-button" type="button" data-bs-toggle="collapse" data-bs-target="#formExpand"
      aria-expanded="false" aria-controls="formExpand" (click)="editMode = false; selectedEvent = null">
      + Create new {{ isActiveTab }}
    </button>
  </div>

  <!-- Event Listing -->
  <div *ngIf="eventsList.length > 0" class="events-list">
    <div class="row">
      <div *ngFor="let event of eventsList" class="col-md-3 col-sm-6 mb-3">
        <div class="event-card" (click)="editEvent(event)">
          <div class="event-media">
            <ng-container *ngIf="event.mediaItems && event.mediaItems.length > 0">
              <img *ngIf="getCurrentMediaItem(event) && !getCurrentMediaItem(event).mediaUrl?.includes('.mp4')" 
                   [src]="getCurrentMediaItem(event).mediaUrl || getCurrentMediaItem(event).link" 
                   [attr.data-index]="getCurrentMediaIndex(event.id)"
                   alt="Event image" 
                   class="media-item" />
              <div *ngIf="getCurrentMediaItem(event) && getCurrentMediaItem(event).mediaUrl?.includes('.mp4')" 
                   class="video-container media-item"
                   [attr.data-index]="getCurrentMediaIndex(event.id)"
                   (mouseenter)="playVideoOnHover($event)"
                   (mouseleave)="pauseVideoOnHover($event)">
                <video [src]="getCurrentMediaItem(event).mediaUrl || getCurrentMediaItem(event).link" 
                       preload="metadata"
                       muted
                       loop></video>
                <div class="play-button-overlay">
                  <div class="play-icon"></div>
                </div>
              </div>
              
              <!-- Navigation arrows -->
              <div *ngIf="event.mediaItems.length > 1" class="media-navigation">
                <button class="nav-arrow nav-arrow-left" 
                        (click)="navigateMedia(event, 'prev', $event)"
                        aria-label="Previous media">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button class="nav-arrow nav-arrow-right" 
                        (click)="navigateMedia(event, 'next', $event)"
                        aria-label="Next media">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
              
              <!-- Media indicator dots -->
              <div *ngIf="event.mediaItems.length > 1" class="media-indicators">
                <span *ngFor="let item of event.mediaItems; let i = index" 
                      class="indicator-dot"
                      [class.active]="getCurrentMediaIndex(event.id) === i"></span>
              </div>
            </ng-container>
            <div *ngIf="!event.mediaItems || event.mediaItems.length === 0" class="no-media">
              <img src="../../../assets/images/media.svg" alt="No media" />
            </div>
          </div>
          <div class="event-info">
            <h4>{{ event.title }}</h4>
            <p class="event-date">{{ event.formattedStartDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Load more button for events -->
  <div
    *ngIf="isActiveTab === 'event' && eventsList.length > 0 && 
           ((eventDateFilter === 'upcoming' && hasMoreUpcomingEvents) || 
            (eventDateFilter === 'past' && hasMorePastEvents))"
    class="events-load-more">
    <button
      type="button"
      class="hover-button load-more-button"
      (click)="eventDateFilter === 'upcoming' ? loadUpcomingEvents(false) : loadPastEvents(false)"
      [disabled]="isLoadingUpcoming || isLoadingPast">
      <span *ngIf="isLoadingUpcoming || isLoadingPast" class="loading-spinner"></span>
      {{ (isLoadingUpcoming || isLoadingPast) ? 'Loading...' : 'Load more events' }}
    </button>
  </div>

  <!-- Empty state for events -->
  <div *ngIf="isActiveTab === 'event' && eventsList.length === 0" class="empty-events">
    <img src="../../assets/images/empty-feed.svg" alt="" />
    <h2 *ngIf="eventDateFilter === 'upcoming'">No upcoming events</h2>
    <h2 *ngIf="eventDateFilter === 'past'">No past events</h2>
    <p *ngIf="eventDateFilter === 'upcoming'">Create your first event to get started.</p>
    <p *ngIf="eventDateFilter === 'past'">Switch back to upcoming or create a new event.</p>
  </div>
</div>

<!-- Collapsible Form -->
<div class="collapse collapse-horizontal new-post" id="formExpand" #formExpand (shown.bs.collapse)="toggleBackdrop(true)"
  (hidden.bs.collapse)="toggleBackdrop(false)">
  <div class="new-post-top">
    <h3>{{ editMode && isActiveTab === 'event' ? 'Edit Event' : 'Create New ' + isActiveTab }}</h3>
    <div>
      <button data-bs-toggle="collapse" data-bs-target="#formExpand" (click)="cancelEdit()">
        <img src="../../assets/images/close-notification.svg" alt="Close" />
      </button>
    </div>
  </div>

  <div class="new-post-bottom">
    <form [formGroup]="postForm" *ngIf="isActiveTab === 'post'" (ngSubmit)="onSubmit()">
      <div>
        <div class="mb-3 input-wrapper">
          <label for="postDetails" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Post description
          </label>
          <textarea class="form-control" id="postDetails" rows="3" placeholder="Short description"
            formControlName="description" maxlength="140"></textarea>
        </div>

        <div class="mb-3 input-wrapper">
          <div class="date-time-wrapper">
            <label for="postStartDateTime" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Start Date &
              Time</label>
            <input type="datetime-local" id="postStartDateTime" class="form-control" formControlName="date" />
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            Skills
            <span class="fw-normal" style="color: rgba(147, 147, 147, 1)">(optional)</span>
          </label>
          <div class="skills-container">
            <div *ngFor="let skill of skillsList" class="skill-item">
              <input type="checkbox" [id]="skill.id" class="skill-checkbox" [formControlName]="'skill_' + skill.id"
                (change)="onCheckboxChange($event, 'skills')" />
              <label [for]="skill.id" class="skill-label">{{
                skill.title
                }}</label>
            </div>
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            Vouchers
            <span class="fw-normal" style="color: rgba(147, 147, 147, 1)">
              (optional)
            </span>
          </label>

          <swiper [spaceBetween]="20" [slidesPerView]="2.5" [pagination]="{ clickable: true }" [breakpoints]="{
              '320': { slidesPerView: 1.5, spaceBetween: 10 },
              '1024': { slidesPerView: 2.5, spaceBetween: 20 }
            }" class="skills-container">
            <ng-template swiperSlide *ngFor="let voucher of vouchersList">1233
              <div class="voucher-item">
                <input type="checkbox" class="voucher-checkbox" [id]="voucher.id"
                  [formControlName]="'voucher_' + voucher.id" (change)="onCheckboxChange($event, 'vouchers')" />
                <label [for]="voucher.id" class="voucher-label">
                  {{ voucher.title }}
                  <div class="voucher-date">{{ voucher.expirationDate }}</div>
                </label>
              </div>
            </ng-template>
          </swiper>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Images
          </label>
          <div class="add-image text-center">
            <img src="../../../assets/images/media.svg" alt="" />
            <h3>Image</h3>
            <p>
              When uploading a 2:1 image, ensure it adjusts smoothly to
              different
              <br />
              screen sizes and is optimized for faster loading.
            </p>
            <label for="postMedia" class="add-image-label hover-button">
              + Add image
            </label>
            <br />
            <input type="file" style="visibility: hidden; height: 0" id="postMedia"
              accept="image/png, image/gif, image/jpeg" multiple (change)="onMediaChange($event)" />
          </div>
        </div>

        <div class="selected-media" *ngIf="selectedMedia.length > 0">
          <ul>
            <li *ngFor="let file of selectedMedia; let i = index" [ngClass]="{ 'invalid-file': file.invalid }">
              <div class="selected-info">
                <ng-container *ngIf="file.thumbnail">
                  <img *ngIf="!file.isVideo" [src]="file.thumbnail" alt="Selected image" />
                  <video *ngIf="file.isVideo" [src]="file.thumbnail" controls preload="metadata"></video>
                </ng-container>
                <img *ngIf="!file.thumbnail && file.invalid" src="../../../assets/images/not-supported-file.svg"
                  alt="Selected media" />
                <div>
                  <p>
                    {{ file.name }}
                  </p>
                  <small *ngIf="!file.invalid && file.size !== 0">
                    {{ (file.size / (1024 * 1024)).toFixed(2) }} MB
                  </small>
                  <small *ngIf="file.invalid"> {{ file.errorMessage }} </small>
                </div>
              </div>
              <button class="border-0 bg-transparent hover-button" (click)="removeFile(i)">
                <img src="../../../assets/images/TrashSimple.svg" alt="Delete" />
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="submit-wrapper">
        <button type="submit" [disabled]="!postForm.valid || !mediaValid" class="submit-btn hover-button">
          Publish Post
        </button>
      </div>
    </form>

    <form [formGroup]="activityForm" *ngIf="isActiveTab === 'activity'" (ngSubmit)="onSubmit()">
      <div>
        <div class="mb-3 input-wrapper price-wrapper">
          <div>
            <label for="activityName" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Activity
              Name</label>
            <input type="text" id="activityName" placeholder="ex. Brunch Highlights" class="form-control"
              formControlName="name" />
          </div>
          <div class="price-cost-wrapper">
            <label for="activityPrice" class="form-label">Price</label>
            <input type="number" id="activityPrice" placeholder="ex. 2000" class="form-control"
              formControlName="cost" />
            <select class="form-select" formControlName="currency" aria-label="Default select example">
              <option value="MKD">MKD</option>
              <option value="AED">AED</option>
              <option value="RSD">RSD</option>
            </select>
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label for="activityDescription" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Activity
            description
          </label>
          <textarea class="form-control" id="activityDescription" rows="3" placeholder="Short description"
            formControlName="description"></textarea>
        </div>

        <div class="mb-3 input-wrapper">
          <div class="date-time-wrapper">
            <label for="activityStartDateTime" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Start Date &
              Time</label>
            <input type="datetime-local" id="activityStartDateTime" class="form-control" formControlName="date" />
          </div>
        </div>
        <div class="mb-3 input-wrapper years-wrapper">
          <div>
            <label for="activityAgeSuitability" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Ages</label>
            <input type="text" formControlName="ageSuitability" id="activityAgeSuitability"
              placeholder="ex. 0-3 yrs; 7+" class="form-control" />
          </div>
          <div>
            <label for="activityDuration" class="form-label">Duration</label>
            <input type="text" formControlName="duration" id="activityDuration" placeholder="ex. 120"
              class="form-control" />
          </div>
          <div class="activity-price">
            <label class="form-label"> Activity</label>
            <div class="form-check form-switch d-flex justify-content-between align-items-end p-0 w-100 m-0">
              <label class="form-check-label" for="activityOutdoorEvent">Outdoor</label>
              <input class="form-check-input" style="cursor: pointer" type="checkbox" id="activityOutdoorEvent"
                formControlName="outdoorEvent" name="activityOutdoorEvent" />
            </div>
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            Skills
            <span class="fw-normal" style="color: rgba(147, 147, 147, 1)">(optional)</span>
          </label>
          <div class="skills-container">
            <div *ngFor="let skill of skillsList" class="skill-item">
              <input type="checkbox" [id]="skill.id" class="skill-checkbox" [formControlName]="'skill_' + skill.id"
                (change)="onCheckboxChange($event, 'skills')" />
              <label [for]="skill.id" class="skill-label">{{
                skill.title
                }}</label>
            </div>
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            Vouchers
            <span class="fw-normal" style="color: rgba(147, 147, 147, 1)">
              (optional)
            </span>
          </label>

          <swiper [spaceBetween]="20" [slidesPerView]="2.5" [pagination]="{ clickable: true }" [breakpoints]="{
              '320': { slidesPerView: 1.5, spaceBetween: 15 },
              '1024': { slidesPerView: 2.5, spaceBetween: 20 }
            }" class="skills-container">
            <ng-template swiperSlide *ngFor="let voucher of vouchersList">
              <div class="voucher-item">
                <input type="checkbox" class="voucher-checkbox" [formControlName]="'voucher_' + voucher.id"
                  [id]="voucher.title" />
                <label [for]="voucher.title" class="voucher-label">
                  {{ voucher.title }}
                  <div class="voucher-date">{{ voucher.date }}</div>
                </label>
              </div>
            </ng-template>
          </swiper>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Images
          </label>
          <div class="add-image text-center">
            <img src="../../../assets/images/media.svg" alt="" />
            <h3>Image</h3>
            <p>
              When uploading a 2:1 image, ensure it adjusts smoothly to
              different
              <br />
              screen sizes and is optimized for faster loading.
            </p>
            <label for="postMedia" class="add-image-label hover-button">
              + Add image
            </label>
            <br />
            <input type="file" style="visibility: hidden; height: 0" id="postMedia" multiple
              accept="image/png, image/gif, image/jpeg" (change)="onMediaChange($event)" />
          </div>
        </div>

        <div class="selected-media" *ngIf="selectedMedia.length > 0">
          <ul>
            <li *ngFor="let file of selectedMedia; let i = index" [ngClass]="{ 'invalid-file': file.invalid }">
              <div class="selected-info">
                <ng-container *ngIf="file.thumbnail">
                  <img *ngIf="!file.isVideo" [src]="file.thumbnail" alt="Selected image" />
                  <div *ngIf="file.isVideo" class="video-container-small">
                    <video [src]="file.thumbnail" preload="metadata"></video>
                    <div class="play-button-overlay-small">
                      <div class="play-icon-small"></div>
                    </div>
                  </div>
                </ng-container>
                <img *ngIf="!file.thumbnail && file.invalid" src="../../../assets/images/not-supported-file.svg"
                  alt="Selected media" />
                <div>
                  <p>
                    {{ file.name }}
                  </p>
                  <small *ngIf="!file.invalid && file.size !== 0">
                    {{ (file.size / (1024 * 1024)).toFixed(2) }} MB
                  </small>
                  <small *ngIf="file.invalid"> {{ file.errorMessage }} </small>
                </div>
              </div>
              <button class="border-0 bg-transparent hover-button" (click)="removeFile(i)">
                <img src="../../../assets/images/TrashSimple.svg" alt="Delete" />
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="submit-wrapper">
        <button type="submit" [disabled]="!activityForm.valid || !mediaValid" class="submit-btn hover-button">
          Publish Activity
        </button>
      </div>
    </form>

    <form [formGroup]="eventForm" *ngIf="isActiveTab === 'event'" (ngSubmit)="onSubmit()">
      <div>
        <div class="mb-3 input-wrapper">
          <div class="form-check form-switch d-flex align-items-end p-0 m-0">
            <label class="form-check-label" for="isBusinessEvent">{{ businessData.name }} event</label>
            <input class="form-check-input ms-3" style="cursor: pointer" type="checkbox" id="isBusinessEvent"
              name="isBusinessEvent" (change)="isBusinessEvent($event)" />
            <label class="form-check-label ms-3" for="isFeatured">Featured event</label>
            <input class="form-check-input ms-3" style="cursor: pointer" type="checkbox" id="isFeatured"
              name="isFeatured" [checked]="isFeaturedCheckbox" (change)="isFeaturedChange($event)" />
            <label class="form-check-label ms-3" for="isActive">Active</label>
            <input class="form-check-input ms-3" style="cursor: pointer" type="checkbox" id="isActive"
              name="isActive" [checked]="isActiveCheckbox" (change)="isActiveChange($event)" />
          </div>
        </div>
        <div class="mb-3 input-wrapper">
          <label for="eventName" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Event
            Title</label>
          <input type="text" id="eventName" placeholder="ex. Cinema in city" class="form-control"
            formControlName="title" />
        </div>
        <div class="mb-3 input-wrapper">
          <label for="eventDescription" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Event description
          </label>
          <textarea class="form-control" id="eventDescription" rows="3" placeholder="Description"
            formControlName="description"></textarea>
        </div>
        <div class="mb-3 input-wrapper">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label mb-0">Prices</label>
            <div class="d-flex align-items-center">
              <label class="form-label mb-0 me-2">Currency</label>
              <select class="form-select" formControlName="currency" aria-label="Default select example">
                <option value="MKD">MKD</option>
                <option value="AED">AED</option>
                <option value="RSD">RSD</option>
              </select>
            </div>
          </div>
          <div formArrayName="prices">
            <div *ngFor="let priceGroup of prices?.controls; let i = index" [formGroupName]="i" class="add-price-wrapper mb-2">
              <div class="price-field">
                <input type="text" class="form-control" placeholder="Info" formControlName="description" />
              </div>
              <div class="price-field" [style]="prices.controls.length > 1 ? 'margin-right: 1%' : 'margin: 0'">
                <input type="number" class="form-control" placeholder="100" formControlName="price" />
              </div>
              <div *ngIf="!!prices?.controls && prices.controls.length > 1">
                <button type="button" class="remove-price-btn" (click)="removePrice(i)">-</button>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3 input-wrapper currency-wrapper">
          <button type="button" class="add-price-btn" (click)="addPrice()">Add price +</button>
        </div>
        <div class="mb-3 input-wrapper years-wrapper">
          <div class="me-3">
            <label for="eventAgeSuitability" class="form-label">
              <span style="color: rgba(255, 153, 0, 1)">*</span> Ages</label>
            <input type="text" formControlName="ageSuitability" id="eventAgeSuitability" placeholder="ex. 0-3 yrs; 7+"
              class="form-control" />
          </div>
          <div class="activity-price">
            <label class="form-label"> Activity</label>
            <div class="form-check form-switch d-flex align-items-end p-0 w-100 m-0">
              <label class="form-check-label fw-normal " for="eventActivityOutdoorEvent">Outdoor</label>
              <input class="form-check-input ms-2" style="cursor: pointer" type="checkbox" id="eventActivityOutdoorEvent"
                formControlName="outdoorEvent" name="eventActivityOutdoorEvent" />
            </div>
          </div>
        </div>

        <div class=" input-wrapper mb-3 time-wrapper">
          <div class="time-element">
            <label class="form-label"> <span style="color: rgba(255, 153, 0, 1)">*</span> Start Date</label>
            <div [formGroup]="eventForm.get('eventDate')">
              <input type="date" class="form-control" formControlName="startDate" />
            </div>
            <div *ngIf="eventForm.get('eventDate.startDate')?.touched && eventForm.get('eventDate.startDate')?.errors?.['dateInPast']" class="url-error">
              Date cannot be in the past.
            </div>
          </div>
          <div class="time-element">
            <label class="form-label"> <span style="color: rgba(255, 153, 0, 1)">*</span> Start Time</label>
            <div [formGroup]="eventForm.get('eventTime')">
              <input type="time" class="form-control" formControlName="startTime" />
            </div>
          </div>
        </div>

        <div class="mb-3 input-wrapper ">
          <label for="eventPlace" class="form-label">
            <span style="color: rgba(255, 153, 0, 1)" >*</span> Location
          </label>
          <app-map [reset]="resetMapTrigger" [initialLocation]="mapInitialLocation" (placeSelected)="onPlaceSelected($event)"></app-map>
        </div>
        <div class="mb-3 input-wrapper social-wrapper">
          <div>
            <label for="eventWebUrl" class="form-label">Website</label>
            <input type="text" id="eventWebUrl" class="form-control" formControlName="eventWebUrl" placeholder="https://example.com" />
            <div *ngIf="eventForm.get('eventWebUrl')?.touched && eventForm.get('eventWebUrl')?.errors?.['invalidUrl']" class="url-error">
              Please enter a valid website URL.
            </div>
          </div>
          <div>
            <label for="eventPhoneNumber" class="form-label">Phone number</label>
            <input type="text" id="eventPhoneNumber" class="form-control" formControlName="phoneNumber" placeholder="+389 70 123 456" />
            <div *ngIf="eventForm.get('phoneNumber')?.touched && eventForm.get('phoneNumber')?.errors?.['invalidPhone']" class="url-error">
              Please enter a valid phone number.
            </div>
          </div>
        </div>
        <!-- <div class="mb-3 input-wrapper">

        </div> -->

  
        <div class="mb-3 input-wrapper" formGroupName="bookAction">
          <label class="form-label">Book Action</label>
          <div class="row g-2 align-items-center">
            <div class="col-auto">
              <select class="form-select" formControlName="type">
                <option value="call">Phone</option>
                <option value="navigationLink">Web</option>
              </select>
            </div>
            <div class="col">
              <input type="text" class="form-control" formControlName="value" placeholder="Enter phone or web link" />
              <div *ngIf="eventForm.get('bookAction')?.touched && eventForm.get('bookAction')?.errors?.['invalidBookPhone']" class="url-error">
                Please enter a valid phone number for Book Action.
              </div>
              <div *ngIf="eventForm.get('bookAction')?.touched && eventForm.get('bookAction')?.errors?.['invalidBookUrl']" class="url-error">
                Please enter a valid URL for Book Action.
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            Skills
            <span class="fw-normal" style="color: rgba(147, 147, 147, 1)">(optional)</span>
          </label>
          <div class="skills-container">
            <div *ngFor="let skill of skillsList" class="skill-item">
              <input type="checkbox" [id]="skill.id" class="skill-checkbox" [formControlName]="'skill_' + skill.id"
                (change)="onCheckboxChange($event, 'skills')" />
              <label [for]="skill.id" class="skill-label">{{
                skill.title
                }}</label>
            </div>
          </div>
        </div>

        <div class="mb-3 input-wrapper">
          <label class="form-label">
            <span style="color: rgba(255, 153, 0, 1)">*</span> Images
          </label>
          <div class="add-image text-center">
            <img src="../../../assets/images/media.svg" alt="" />
            <h3>Image</h3>
            <p>
              When uploading a 2:1 image, ensure it adjusts smoothly to
              different
              <br />
              screen sizes and is optimized for faster loading.
            </p>
            <label for="postMedia" class="add-image-label hover-button">
              + Add image/video
            </label>
            <br />
            <input type="file" style="visibility: hidden; height: 0" id="postMedia"
              accept="image/png, image/gif, image/jpeg, video/mp4" multiple (change)="onMediaChange($event)" />
          </div>
        </div>

        <div class="selected-media" *ngIf="selectedMedia.length > 0">
          <ul>
            <li *ngFor="let file of selectedMedia; let i = index" [ngClass]="{ 'invalid-file': file.invalid }">
              <div class="selected-info">
                <ng-container *ngIf="file.thumbnail">
                  <img *ngIf="!file.isVideo" [src]="file.thumbnail" alt="Selected image" />
                  <div *ngIf="file.isVideo" class="video-container-small">
                    <video [src]="file.thumbnail" preload="metadata"></video>
                    <div class="play-button-overlay-small">
                      <div class="play-icon-small"></div>
                    </div>
                  </div>
                </ng-container>
                <img *ngIf="!file.thumbnail && file.invalid" src="../../../assets/images/not-supported-file.svg"
                  alt="Selected media" />
                <div>
                  <p>
                    {{ file.name }}
                  </p>
                  <small *ngIf="!file.invalid && file.size !== 0">
                    {{ (file.size / (1024 * 1024)).toFixed(2) }} MB
                  </small>
                  <small *ngIf="file.invalid"> {{ file.errorMessage }} </small>
                </div>
              </div>
              <button class="border-0 bg-transparent hover-button" (click)="removeFile(i)">
                <img src="../../../assets/images/TrashSimple.svg" alt="Delete" />
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="submit-wrapper">
        <button type="submit" [disabled]="!eventForm.valid || !mediaValid" class="submit-btn hover-button">
          {{ editMode ? 'Update Event' : 'Create Event' }}
        </button>
      </div>
    </form>
  </div>
</div>

<div class="sidebar-backdrop" data-bs-toggle="collapse" data-bs-target="#formExpand" #backdrop></div>

<!-- Toast container -->
<div #postToast class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive"
  aria-atomic="true">
  <div class="d-flex">
    <div class="toast-body">Post <span>{{ toastMessage }}</span> successfully!</div>
  </div>
</div>